import { useEffect, useState } from "react";
import {
  Table,
  Container,
  Button,
  Modal,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
 
import { fetchWorkingDays, addWorkingDay } from "../Api/WorkingDays";
import { fetchCompnayCodesById } from "../Api/InvoiceApi";
 
const WorkingDays = () => {
  const [workingDays, setWorkingDays] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [companyCodes, setCompanyCodes] = useState([]);
 
  const [form, setForm] = useState({
    companyCode: "",
    workingYear: "",
    workingMonth: "",
    calendarDays: "",
    workingDays: "",
  });
 
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const organisationId = userDetails?.organisationId;
  const createdBy = userDetails?.username;
 
  // Load working days list
  const loadWorkingDays = async () => {
    try {
      const data = await fetchWorkingDays(organisationId);
      setWorkingDays(data || []);
    } catch (error) {
      toast.error(`Error fetching working days: ${error?.message}`);
    }
  };
 
  useEffect(() => {
    loadWorkingDays();
  }, []);
 
  // Open modal
  const openModal = async () => {
    try {
      const codes = await fetchCompnayCodesById(organisationId);
      setCompanyCodes(codes || []);
    } catch {
      toast.error("Failed to load company codes");
    }
 
    setForm({
      companyCode: "",
      workingYear: "",
      workingMonth: "",
      calendarDays: "",
      workingDays: "",
    });
 
    setShowModal(true);
  };
 
  const handleMonthChange = (value) => {
    const year = form.workingYear;
    if (!year) {
      return toast.error("Please select year first");
    }
 
    const days = new Date(year, value, 0).getDate();
    setForm({ ...form, workingMonth: value, calendarDays: days });
  };
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
 
  // Save data to backend
const handleSubmit = async () => {
  try {
    const payload = {
     Organisation_id: organisationId,
CompanyCode: form.companyCode,
  WorkingYear: form.workingYear,
  WorkingMonth: form.workingMonth,
  CalendarDays: String(form.calendarDays),
  WorkingDays: form.workingDays,
  CreatedBy: createdBy
    };
 
    const res = await addWorkingDay(payload);
 
    toast.success("Working Days Added Successfully!");
    setShowModal(false);
    loadWorkingDays();
  } catch (error) {
    toast.error("Failed to add working days");
  }
};
 
  const formatDateTime = (date) => {
    if (!date) return "N/A";
    return moment(date).format("DD-MM-YYYY hh:mm:ss A");
  };
 
  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="list-title">Working Days Master</span>
 
          <Button variant="primary" onClick={openModal}>
            + Add Working Days
          </Button>
        </div>
 
        {workingDays.length > 0 ? (
          <div className="table-wrapper">
            <div className="table-scroll-container">
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Calendar Days</th>
                    <th>Working Days</th>
                    <th>Working Start Date</th>
                    <th>Working End Date</th>
                  </tr>
                </thead>
 
                <tbody>
                  {workingDays.map((day, index) => (
                    <tr key={day.workingDaysId || index}>
                      <td>{index + 1}</td>
                      <td>{day.workingDaysId}</td>
                      <td>{day.workingYear}</td>
                      <td>{day.workingMonth}</td>
                      <td>{day.calendarDays}</td>
                      <td>{day.workingDays}</td>
                      <td>{day.workingStartDate.split('T')[0]}</td>
                      <td>{day.workingEndDate.split('T')[0]}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <p className="no-data">No working days data found.</p>
        )}
      </Container>
 
      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Working Days</Modal.Title>
        </Modal.Header>
 
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Company Code</Form.Label>
                  <Form.Select
                    name="companyCode"
                    value={form.companyCode}
                    onChange={handleChange}
                  >
                    <option value="">Select Company Code</option>
                    {companyCodes.map((cc) => (
                      <option key={cc.companyCode} value={cc.companyCode}>
                        {cc.companyCode} - {cc.companyName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
 
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Year</Form.Label>
                  <Form.Select
                    name="workingYear"
                    value={form.workingYear}
                    onChange={handleChange}
                  >
                    <option value="">Select Year</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
 
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Month</Form.Label>
                  <Form.Select
                    name="workingMonth"
                    value={form.workingMonth}
                    onChange={(e) => handleMonthChange(e.target.value)}
                  >
                    <option value="">Select Month</option>
                    {[...Array(12)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {moment().month(i).format("MMMM")}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
 
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Calendar Days</Form.Label>
                  <Form.Control type="number" value={form.calendarDays} readOnly />
                </Form.Group>
              </Col>
            </Row>
 
            <Form.Group className="mb-3">
              <Form.Label>Working Days</Form.Label>
              <Form.Control
                type="number"
                name="workingDays"
                value={form.workingDays}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
 
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
 
export default WorkingDays;